import { usePrivilege } from "hooks‬/PrivilegeContext";
import { hasAccess } from "helpers/privileges/utils";

export const useFeatureAccess = (feature: string) => {
  const { privileges, hasActivePlan } = usePrivilege();

  return {
    canRead: hasAccess(feature, "READ", privileges, hasActivePlan),
    canModify: hasAccess(feature, "MODIFY", privileges, hasActivePlan),
    canCreate: hasAccess(feature, "CREATE", privileges, hasActivePlan),
    canDelete: hasAccess(feature, "DELETE", privileges, hasActivePlan),
  };
};
